export default __webpack_public_path__ + "static/media/Tiger's Belt of Pierced Flesh.3d65f9ef.jpg";